import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {RewardGeneratorMode} from "./RewardGeneratorMode";
import {RewardGeneratorConfig} from "./RewardGeneratorConfig";
import {GuardConfig} from "../guard/GuardConfig";
import {Schema} from "@/common/Schema";

export class RewardGeneratorModel extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(RewardGeneratorModel, v) : SKIP;
            },
            (v) => {
                return deserialize(RewardGeneratorModel, v);
            }
        );
    }

    constructor() {
        super();
        this._name = "";
        this._guard = new GuardConfig();

        this._mode = RewardGeneratorMode.DEFAULT;
        this._amountMin = 0;
        this._amountMax = 0;
        this._data = [];
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get mode() {
        return this._mode;
    }

    set mode(value) {
        this._mode = value;
    }

    get amountMin() {
        return this._amountMin
    }

    set amountMin(value) {
        this._amountMin = value;
    }

    get amountMax() {
        return this._amountMax
    }

    set amountMax(value) {
        this._amountMax = value;
    }

    get data() {
        return this._data;
    }

    set data(value) {
        this._data = value;
    }

    valid() {

        if (!RewardGeneratorMode.is(this.mode)) {
            return false;
        }

        if (RewardGeneratorMode.AMOUNT.equal(this.mode)) {

            if (!Number.isInteger(this.amountMin) || this.amountMin < 0) {
                return false;
            }

            if (!Number.isInteger(this.amountMax) || this.amountMax <= 0) {
                return false;
            }
        }


        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (!this.data || this.data.length === 0) {
            return false;
        }

        return !this.data.some(v => !v || !v.valid());
    }

    empty() {
        return this.data.length === 0;
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new RewardGeneratorModel());
        } else if (target instanceof RewardGeneratorModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(RewardGeneratorModel, {
    _name: alias("name", Schema.primitive()),
    _guard: alias("guard", GuardConfig.schema()),

    _mode: alias("mode", RewardGeneratorMode.schema()),
    _data: alias("data", list(RewardGeneratorConfig.schema())),
    _amountMin: alias("amount_min", Schema.primitive()),
    _amountMax: alias("amount_max", Schema.primitive())
});